export enum AuthType {
  BASIC = 'BASIC',
  STUDENT = 'STUDENT',
  LECTURER = 'LECTURER',
}
